import SysColumn from "app/class/sys-column";
import SysTable from "app/class/sys-table";
import { createContext, useContext } from "react";
import { UseFormReturn } from "react-hook-form";
import { ClientScriptEventType } from "../services/clientScriptRuntime";

export type RecordProducerContextType = {
    table: SysTable;
    columns: SysColumn[];
    form: UseFormReturn<any>;
    mode: "create" | "edit";
    embedded?: boolean;
    recordId?: string | null;
    translationKeys?: Record<string, string>;
    attachmentDraftToken?: string | null;
    runClientScripts?: (eventType: ClientScriptEventType) => Promise<boolean>;
    dispatchSameValueFieldChange?: (fieldName: string) => void;
    registerPendingTranslation?: (fieldName: string, flush: () => Promise<boolean>) => () => void;
    flushPendingTranslations?: () => Promise<boolean>;
};

export const RecordProducerContext = createContext<RecordProducerContextType | null>(null);

export function useRecordProducer() {
    const ctx = useContext(RecordProducerContext);
    if (!ctx) {
        throw new Error("useRecordProducer must be used inside RecordProducer");
    }
    return ctx;
}
